import {ShiftEvent} from '@hconnect/common/types'
import {selectableTableRowSx} from '@hconnect/uikit'
import {DataTable, Column} from '@hconnect/uikit/src/lib2'
import {Stack, Box} from '@mui/material'
import {EventTypeLabel, EventStatusLabel} from '@widgets/common-shift-event'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {getEventsByCategory} from '../utils'

const CATEGORIES_TO_DISPLAY = ['mechanical', 'electrical']

type EventsByCategoryProps = {
  events: ShiftEvent[]
  isMobile: boolean
  onEventClick?: () => void
}

const getEventTypeWithTitleColumn = (categoryTitle: string): Column<ShiftEvent> => ({
  key: 'eventType',
  label: categoryTitle,
  customTemplate: (item: ShiftEvent) => (
    <Box display="flex" alignItems="center">
      <EventTypeLabel eventType={item.eventType} iconOnly={true} sx={{mr: 1}} />
      {item.title}
    </Box>
  )
})

const getStatusColumn = (isMobile: boolean): Column<ShiftEvent> => ({
  key: 'status',
  customTemplate: (item: ShiftEvent) => (
    <EventStatusLabel
      status={item.status}
      iconOnly={isMobile}
      sx={{textAlign: 'right', display: 'block'}}
    />
  )
})

const getColumns = (categoryTitle: string, isMobile: boolean) => [
  getEventTypeWithTitleColumn(categoryTitle),
  getStatusColumn(isMobile)
]

export const MajorOutageLeadEvents = ({events, isMobile, onEventClick}: EventsByCategoryProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const eventsByCategory = getEventsByCategory(events)

  return (
    <Stack spacing={2}>
      {CATEGORIES_TO_DISPLAY.map((category) => {
        const categoryEvents = eventsByCategory[category]
        if (categoryEvents === undefined) {
          return null
        }
        const categoryTitle = t(`shiftEvent.category.${category}`)
        const columns = getColumns(categoryTitle, isMobile)

        return (
          <Box key={category}>
            <DataTable<ShiftEvent>
              columns={columns}
              data={categoryEvents}
              data-test-id={`events-table-${category}`}
              onRowClick={onEventClick}
              rowSx={() => selectableTableRowSx(false)}
            />
          </Box>
        )
      })}
    </Stack>
  )
}
